import _ from 'underscore';
import { projectionGridBulkEdit } from '@bingads-webui-campaign/projection-grid-bulk-edit';

/**
 * @typedef { Object } settingsBulkEditOptions
 * @property { Object } status settings status schema.
 * @property { Object } ChangeStatusView settings change status view.
 * @property { Object } ChangeStatusModel settings change status model.
 * @property { Object } ChangeUrlOptionsView settings change url options view.
 * @property { Object } ChangeUrlOptionsModel settings change url options model.
 * @property { Object } config config.
 * @property { Object } i18n i18n.
 */

/**
 * settingsBulkEdit
 * @param { settingsBulkEditOptions } options settings bulk edit options
 * @returns { Object } settingsBulkEditPlugin settings bulk edit plugin
 */
function settingsBulkEdit(options) {
  const {
    status,
    ChangeStatusView,
    ChangeStatusModel,
    ChangeUrlOptionsView,
    ChangeUrlOptionsModel,
    config,
    filterService,
    i18n,
  } = options;

  function getChangeUrlOptionView({ viewConfig, selectedRowCount }) {
    return new ChangeUrlOptionsView(_.defaults({
      entityType: 'Campaign',
      model: new ChangeUrlOptionsModel({
        selectedEntityCount: selectedRowCount,
      }),
    }, viewConfig));
  }

  const items = [{
    text: i18n.getString('ChangeUrlOptions'),
    classes: ['bulk-edit-change-url-option'],
    createView: getChangeUrlOptionView,
  }];

  return projectionGridBulkEdit({
    status,
    ChangeStatusView,
    ChangeStatusModel,
    entityType: 'campaign',
    config,
    filterService,
    i18n,
    items,
    showDelete: false,
  });
}

export { settingsBulkEdit };
